import { countries, getStateList } from "../constants/dropdown";

const COUNTRY_MAP = {
  "UNITED STATES": "USA",
  USA: "USA",
  US: "USA",
  INDIA: "IND",
  CANADA: "CAN",
  MEXICO: "MEX",
  BRAZIL: "BRA",
  ARGENTINA: "ARG",
};

const parsePhone = (phoneStr) => {
  if (!phoneStr) {
    return { phoneCountryCode: "1", phone: "" };
  }

  const digits = phoneStr.replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) {
    return { phoneCountryCode: "1", phone: digits.slice(1) };
  }
  if (digits.length === 10) {
    return { phoneCountryCode: "1", phone: digits };
  }
  if (digits.length > 10) {
    return {
      phoneCountryCode: digits.slice(0, digits.length - 10),
      phone: digits.slice(-10),
    };
  }

  return { phoneCountryCode: "1", phone: digits };
};

const normalizeCountry = (country) => {
  if (!country) {
    return "USA";
  }

  const normalized = country.trim().toUpperCase();
  if (COUNTRY_MAP[normalized]) {
    return COUNTRY_MAP[normalized];
  }

  const matchedCountry = countries.find(
    (item) =>
      item.value.toUpperCase() === normalized ||
      item.title.toUpperCase() === normalized
  );
  return matchedCountry ? matchedCountry.value : "USA";
};

const parseStateAndZip = (stateValue, zipValue) => {
  let state = (stateValue || "").trim();
  let zip = (zipValue || "").trim().replace(/,$/, "");

  const combinedMatch = state.match(/^([A-Za-z]{2})\s+([A-Za-z0-9-]{3,10})$/);
  if (combinedMatch) {
    return {
      state: combinedMatch[1].toUpperCase(),
      zip: zip || combinedMatch[2],
    };
  }

  return {
    state,
    zip: zip.replace(/[^A-Za-z0-9 ]/g, "").trim(),
  };
};

const matchState = (stateList, stateValue) => {
  if (!stateValue || !stateList.length) {
    return "";
  }

  const normalized = stateValue.trim().toUpperCase();
  const byValue = stateList.find((item) => item.value.toUpperCase() === normalized);
  if (byValue) {
    return byValue.value;
  }

  const byTitle = stateList.find(
    (item) => item.title.trim().toUpperCase() === normalized
  );
  if (byTitle) {
    return byTitle.value;
  }

  return "";
};

const mapContactParseResponse = (response) => {
  const { phoneCountryCode, phone } = parsePhone(response.phone);
  const fullName = [response.first_name, response.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();

  return {
    fullName,
    email: response.email || "",
    phoneCountryCode,
    phone,
    country: "",
    state: "",
    city: "",
    zip: "",
    source: "",
    stateList: [],
  };
};

const mapCandidateParseResponse = (candidate) => {
  const country = normalizeCountry(candidate.address?.country);
  const stateList = getStateList(country);
  const { phoneCountryCode, phone } = parsePhone(candidate.communication?.phone);
  const { state, zip } = parseStateAndZip(
    candidate.address?.state,
    candidate.address?.zip
  );

  return {
    fullName: candidate.fullName || "",
    email: candidate.communication?.email || "",
    phoneCountryCode,
    phone,
    country,
    state: matchState(stateList, state),
    city: candidate.address?.city || "",
    zip,
    source: candidate.source || "",
    stateList,
  };
};

export const mapParsedResumeToForm = (response) => {
  if (!response || response.error) {
    return null;
  }

  if (response.first_name || response.last_name || response.email || response.phone) {
    return mapContactParseResponse(response);
  }

  const candidate = response.candidateList?.[0] || response;
  if (candidate.fullName || candidate.communication || candidate.address) {
    return mapCandidateParseResponse(candidate);
  }

  return null;
};

export const isParseResumeError = (response) => {
  if (!response || response.error) {
    return true;
  }

  if (response.message && response.message !== "SUCCESS") {
    return true;
  }

  return false;
};
